import {
    useEffect,
    useState,
} from 'react';

import {
    useDispatch,
    useSelector,
} from 'react-redux';
import { PermissionAction } from 'src/actions/permission.acction';

import {
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    FormControlLabel,
    FormGroup,
    TextField,
    Typography,
    Grid,
    Box,
    Select as Select1,
    InputAdornment,
    SvgIcon,
    MenuItem,
} from '@material-ui/core';

import ReactSelect from 'react-select';

import { Search as SearchIcon } from 'react-feather';

import {
    DatePicker,
    LocalizationProvider,
  } from '@mui/x-date-pickers';
  import {
    DEFAULT_ROW_PER_PAGE,
    LOAI_GOI_CUOC,
    POST_EDITOR_FONTS,
    POST_EDITOR_FONT_SIZES,
    OPERATOR_THEME,
    CU_PHAP_DANG_KY_GOI_CUOC,
    MAXIMUM_IMAGES,
  } from 'src/utils/constants';
  import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import moment from 'moment';

import { Helmet } from "react-helmet";

import numeral from 'numeral';

import PostEditor from "../../components/PostEditor";
import ImageUploader from "../../components/ImageUploader";
import { LocationAction } from 'src/actions/location.action';
import { ProductAction } from 'src/actions/product.action';
import ProductPrice2 from '../product-detail/ProductPrice2';
import CustomSlider2 from '../CustomSlider2';

const ProductViewDialog = (props) => {
    const maximumImages = MAXIMUM_IMAGES;
    const dispatch = useDispatch()
    const [selectedPermissionIds, setSelectedPermissionIds] = useState([]);
    const { role } = useSelector(state => state.profile);
    const { items } = useSelector(state => state.permission)
    // const { homepageProductSelected } = useSelector(state => state.product)

    const [provinces, setProvinces] = useState([]);
    const [districts, setDistricts] = useState([]);
    const [wards, setWards] = useState([]);
    const [itemId, setItemId] = useState("");
    const [name, setName] = useState("");
    const [image, setImage] = useState("");
    const [price, setPrice] = useState("");
    const [price_new, setPriceNew] = useState("");
    const [operator, setOperator] = useState("");
    const [operator1, setOperator1] = useState("");
    const [time_by_month, setTimeByMonth] = useState("");
    const [description, setDescription] = useState("");
    const [short_description, setShortDescription] = useState("");
    const [tinh_trang, setTinhTrang] = useState("");
    const [tinh_trang_color, setTinhTrangColor] = useState("");
    const [images, setImages] = useState([]);
    const [prices, setPrices] = useState([]);

    const [formData, setFormData] = useState({
        name: "",
        phone: "",
        email: "",
        province: "-99",
        province_name: "",
        district: "-99",
        district_name: "",
        ward: "-99",
        ward_name: "",
        address: "",
        note: "",
        paymentMethod: "cod",
        quantity: 1,
        itemId,
    });

    useEffect(() => {
        console.log(props.product);
        let homepageProductSelected = props.product;

        setName('');
        setImage('');
        setPrice('');
        setPriceNew('');
        setOperator('');
        setTimeByMonth('');
        setDescription('');
        setShortDescription('');
        setTinhTrang('');
        setTinhTrangColor('');
        setImages([]);
        setPrices([]);

        if (homepageProductSelected) {
            setName(homepageProductSelected.name ? homepageProductSelected.name : '');
            setImage(homepageProductSelected.image ? homepageProductSelected.image : '');
            setPrice(homepageProductSelected.price ? Number(homepageProductSelected.price) : '0');
            setPriceNew(homepageProductSelected.price_new ? Number(homepageProductSelected.price_new) : '0');
            setOperator(homepageProductSelected.operator)
            setOperator1(homepageProductSelected.operator == "MOBIFONE" ? "-160px 3px" : (homepageProductSelected.operator == "VINAPHONE" ? "-80px 3px" : "0px 3px"))
            setTimeByMonth(homepageProductSelected.time_by_month ? numeral(homepageProductSelected.time_by_month).format('0,0') + ' tháng' : '0 tháng');
            setDescription(homepageProductSelected.description ? homepageProductSelected.description : '');
            setShortDescription(homepageProductSelected.short_description ? homepageProductSelected.short_description : '');
            
            setTinhTrang(homepageProductSelected.trang_thai == 'con_hang' ? 'Còn hàng' : (homepageProductSelected.trang_thai == 'giu_so' ? '' : 'Hết hàng'))
            setTinhTrangColor(homepageProductSelected.trang_thai == 'con_hang' ? 'green' : (homepageProductSelected.trang_thai == 'giu_so' ? 'orange' : 'red'))

            let _images = [];

            if (homepageProductSelected.images && homepageProductSelected.images.length > 0) {
                _images = [...homepageProductSelected.images].sort((a, b) => a.index - b.index);
            }

            setImages(_images);

            let _prices = [];

            if (homepageProductSelected.prices && homepageProductSelected.prices.length > 0) {
                _prices = [...homepageProductSelected.prices].sort((a, b) => a.index - b.index);
            }

            setPrices(_prices);
            
            async function fetchData() {
                try {
                    let getProvinces = await dispatch(LocationAction.getProvinces());
                    console.log(getProvinces);
                    setProvinces(getProvinces);
                } catch (error) {
                    console.error(error);
                }
            }

            fetchData();
        }
    }, [props.productId])

    useEffect(() => {
        async function fetchData() {
            try {
                setFormData({ 
                    ...formData, 
                    ward: "-99", 
                    ward_name: "", 
                });
                setWards([]);
                let getWards = await dispatch(LocationAction.getWardsByDistrict(formData.district));
                console.log(getWards);
                setWards(getWards);
            } catch (error) {
                console.error(error);
            }
        }

        fetchData();
    }, [formData.province, formData.district])

    useEffect(() => {
        async function fetchData() {
            try {
                setFormData({ 
                    ...formData, 
                    district: "-99",
                    district_name: "", 
                });
                setDistricts([]);
                let getDistricts = await dispatch(LocationAction.getDistrictsByProvince(formData.province));
                console.log(getDistricts);
                setDistricts(getDistricts);
            } catch (error) {
                console.error(error);
            }
        }

        fetchData();
    }, [formData.province])

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleChange1 = (key, value, key1 = null, value1 = null) => {
        if (key1 && value1) {
            setFormData({ 
                ...formData, 
                [key]: value,
                [key1]: value1,
            });
        } else {
            setFormData({ 
                ...formData, 
                [key]: value 
            });
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(ProductAction.sendOrder({...formData, priceIndex: props.priceIndex}));
    };

    const handlePriceChange = (productId, priceIndex) => {
        console.log(productId, ' || ', priceIndex);

        // Gán giá trị mặc định
        // queryParams.set("priceIndex", priceIndex);

        // Cập nhật URL mà không reload trang
        // navigate({
        //     pathname: location.pathname,
        //     search: `?${queryParams.toString()}`
        // }, { replace: true }); // replace để không thêm vào lịch sử trình duyệt
    }

    return (<>
        <Helmet>
            <style>{`
                .otp-close-btn {
                    position: absolute;
                    top: 12px;
                    right: 12px;
                    background-color: red;
                    color: white;
                    border: none;
                    border-radius: 50%;
                    width: 32px;
                    height: 32px;
                    font-size: 20px;
                    font-weight: bold;
                    line-height: 32px;
                    text-align: center;
                    cursor: pointer;
                    z-index: 10;
                }
  
                .otp-container {
                    width: 100%;
                    /* max-width: 480px; */
                    margin: auto;
                    /* padding: 16px; */
                    box-sizing: border-box;
                    font-family: Mulish, sans-serif;
                }
            `}</style>
        </Helmet>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Dialog className='view-product-dialog' style={{zIndex: 999999}} open={props.open} onClose={props.handleClose}>
                {/* <DialogTitle>{props.type === 'EDIT' ? "Cập nhật bản ghi" : "Tạo bản ghi mới"}</DialogTitle> */}
                <DialogContent className='order_container'>
                    <div className="otp-container">
                        {/* Nút đóng */}
                        <button className="otp-close-btn" onClick={props.handleClose}>
                            &times;
                        </button>
                        {name && <>
                            <div className='product-one-detail-container' style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "20px 0 20px 0", background: "transparent", borderRadius: "10px" }}>
                                <CustomSlider2 className="product-one-banner" banners={images} showSlideCount={1} showPrevBtn={1} showNextBtn={1} />
                                <div className='product-one-detail' style={{ display: "block", gridTemplateColumns: "100px auto", gap: "10px", width: "50%", padding: "0 0 0 20px", alignItems: 'center' }}>
                                    <span className='title' style={{color: 'var(--text-color)', fontWeight: '600', padding: "0"}}>{name}</span>
                                    <span className='price' style={{color: 'var(--main-color)', fontWeight: '800'}}>
                                        {/* {
                                            price_new > 0 && price_new < price ? (
                                                <div>
                                                    <span style={{ color: "red", fontWeight: "800" }}>{numeral(price_new).format("0,0")}₫</span>
                                                    <span className='price-old' style={{ textDecoration: "line-through", color: "#888" }}>{numeral(price).format("0,0")}₫</span>
                                                </div>
                                            ) : (
                                                <div>
                                                    <span style={{ fontWeight: "800" }}>{numeral(price).format("0,0")}₫</span>
                                                </div>
                                            )
                                        } */}
                                        <ProductPrice2 product={props.product} index={props.priceIndex} onSelectChange={(priceIndex) => handlePriceChange(itemId, priceIndex)} />
                                    </span>
                                    <div className='product-short-content' style={{padding: "20px 0 20px 0", color: 'gray'}} dangerouslySetInnerHTML={{ __html: short_description }} />
                                </div>
                            </div>
                            <div className='product-content media-content' style={{padding: "0 0 20px 0"}} dangerouslySetInnerHTML={{ __html: description }} />
                        </>}
                    </div>
                </DialogContent>
                {/* <DialogActions>
                    <Button onClick={props.handleClose}>Huỷ</Button>
                    <Button onClick={onPressPositive}>{props.type === 'EDIT' ? "Cập nhật" : "Tạo"}</Button>
                </DialogActions> */}
            </Dialog >
        </LocalizationProvider>
    </>);
}

export default ProductViewDialog;